import React, { useEffect, useState } from 'react';
import { WA_GENERAL } from '../services/whatsapp';
import './WhatsAppButton.css';

export default function WhatsAppButton() {
  const [tip, setTip] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setTip(true), 5000);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="wafab">
      {tip && <button className="wafab__tip" onClick={() => setTip(false)}>¿Planeamos tu viaje? <span>Escríbeme</span></button>}
      <a className="wafab__btn" href={WA_GENERAL} target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp"><i className="fa-brands fa-whatsapp" /></a>
    </div>
  );
}
